/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Provides GEO-related services, such as retrieving user's IP or location info
 *
 * @module enervee_utils.geo
 */
GeoService.$inject = [
    '$http',
    '$q',
    '$log',
    'UtilService',
    'GetFetchService',
];
function GeoService(
    $http,
    $q,
    $log,
    UtilService,
    GetFetchService
) {
    var _pub = {};
    var GEOIP_KEY = UtilService.getSiteSetting('geoip_key', '');
    var GEOIP_URL = 'https://pro.ip-api.com/json/?key=' + GEOIP_KEY;
    var LOCATION_URL ='/api/1.0/geo/zipcode-location/';

    const IPIFY_URL = 'https://api.ipify.org?format=json';


    /**
     * Makes a request to get the latitude and longitude from the current user's IP.
     */
    _pub.getUserLatLng = function () {
        var defer = $q.defer();
        var options = {
            'url': GEOIP_URL,
            'method': 'GET'
        };

        GetFetchService.get(['location'], options).then(function (data) {
            var latLng;
            if (data === undefined) {
                $log.warn("Location not found.");
                latLng = {};
            } else {
                latLng =  {'lat': data.lat, 'lng': data.lon};
            }
            defer.resolve(latLng);
        }, function error(data){
            $log.error(data);
            defer.reject({reason: data});
        });
        return defer.promise;
    };

    /**
     * Obtains user's coordinates from user's zipcode
     * @param zipCode
     * @returns {*}
     */
    _pub.getInfoFromZipcode = function(zipCode) {
        var defer = $q.defer();
        var options = {
            'url': LOCATION_URL + zipCode + '/',
            'method': 'GET'
        };

        GetFetchService.get(['location_zipcode', zipCode], options).then(function (data) {
            var latLng;
            if (data === undefined) {
                $log.warn("Location from zipcode No results found in db.");
                latLng = {};
            } else {
                latLng =  data;
            }
            defer.resolve(latLng);
        }, function error(data){
            $log.error(data);
            defer.reject({reason: data});
        });

        return defer.promise;
    };

    /**
     * Obtains user's zipcode
     *  and uses default value if response
     * couldn't be obtained
     * @returns {*}
     */
    _pub.getUserZipcode = function () {
        var defer = $q.defer();
        var options = {
            'url': GEOIP_URL,
            'method': 'GET'
        };

        GetFetchService.get(['location'], options).then(function (data) {
            let zipcode = null;
            if (data === undefined) {
                $log.warn("Location not found.");
            } else {
                zipcode = data.zip;
            }
            defer.resolve(zipcode);
        }, function error(data){
            $log.error(data);
            defer.reject({reason: data});
        });

        return defer.promise;
    };

    /**
     * Obtains user's IP address and uses
     * @returns {*}
     */
    _pub.getCurrentIPAddress = function () {
         return GetFetchService.get('ip_address', IPIFY_URL);
    };


    return _pub;
}

module.exports = GeoService;
